var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-value-map-link');
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity } from '../../hooks/use-entity';
import { useMapUtils } from '../../hooks/use-map-state';
import { EntityValue } from './entity-value';
import { pickBy } from 'lodash';
export var EntityValueMapLinkDefaultProps = {
  zoom: 3.5,
  deselect: true,
  showMap: true
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var canLink = _a.canLink;
    return canLink && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      cursor: pointer;\n      &:hover {\n        color: ", ";\n      }\n    "], ["\n      color: ", ";\n      cursor: pointer;\n      &:hover {\n        color: ", ";\n      }\n    "])), theme.COLOR('link'), theme.COLOR('link-hover'));
  })
}); // -------- Components -------->

var My = {
  Container: styled(EntityValue)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var EntityValueMapLink = function EntityValueMapLink(props) {
  var className = props.className,
      children = props.children,
      inputEntity = props.entity,
      options = __rest(props, ["className", "children", "entity"]);

  var entity = useEntity(inputEntity);
  var canLink = !!(entity.latitude && entity.longitude);
  var showEntity = useMapUtils().showEntity; // todo - pull this from entity when mapOptions is implemented 

  var onClick = function onClick() {
    showEntity(entity, options);
  };

  var containerProps = pickBy({
    role: canLink && 'button',
    onClick: canLink && onClick
  });
  return React.createElement(My.Container, __assign({
    canLink: canLink
  }, containerProps, {
    entity: entity,
    className: cls.name(className)
  }), children);
};
EntityValueMapLink.defaultProps = EntityValueMapLinkDefaultProps;
EntityValueMapLink.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;